import { render, staticRenderFns } from "./policies.kubewarden.io.admissionpolicy.vue?vue&type=template&id=3ba5f6bc&"
import script from "./policies.kubewarden.io.admissionpolicy.vue?vue&type=script&lang=js&"
export * from "./policies.kubewarden.io.admissionpolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports